module.exports = __webpack_public_path__ + "fonts/DIN-Medium.1bbe3460.otf";